<h1 mat-dialog-title>
  {{ (isCreating ? 'organizationAdmin.groups.dialog.createTitle' : 'organizationAdmin.groups.dialog.renameTitle') | transloco }}
</h1>

<mat-dialog-content [formGroup]="form">
  <div class="field-group">
    <span class="field-label">{{ 'organizationAdmin.groups.dialog.nameLabel' | transloco }} *</span>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <input matInput formControlName="name" />
      @if (form.controls.name.hasError('nameAlreadyUsed')) {
        <mat-error>{{ 'organizationAdmin.groups.dialog.nameAlreadyUsed' | transloco }}</mat-error>
      }
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <span class="dialog-actions-spacer"></span>
  <button mat-button color="primary" class="link-button" type="button" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
    {{ 'common.buttons.cancel' | transloco }}
  </button>
  <button mat-flat-button color="primary" type="button" [disabled]="form.invalid" (click)="save()">
    <mat-icon>check</mat-icon>
    {{ 'common.buttons.save' | transloco }}
  </button>
</mat-dialog-actions>
